// extracted by mini-css-extract-plugin
export default {"navbar":"ListPage_navbar__nqdg5"};